import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define types for the search data
export interface SearchResult {
    id: string;
    title: string;
    summary: string;
    imageUrl: string;
    imageAltText: string;
    imageFocalPoint?: string;
    contentType: string;
    date: string;
    author: string;
    index: number;
    url?: string;
    tags?: string[];
    venue?: string;
    isFeatured?: boolean;
}

export interface FilterCategories {
    contentTypes: string[];
    tags: string[];
}

export interface SearchDataResponse {
    results: SearchResult[];
    totalCount: number;
    contentTypes?: string[];
    tags?: string[];
}

interface SearchDataState {
    searchResults: SearchResult[];
    totalCount: number;
    filterCategories: FilterCategories;
    isLoading: boolean;
    error: string | null;
}

const initialState: SearchDataState = {
    searchResults: [],
    totalCount: 0,
    filterCategories: {
        contentTypes: [],
        tags: []
    },
    isLoading: false,
    error: null
};

const searchDataSlice = createSlice({
    name: 'searchData',
    initialState,
    reducers: {
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
            if (action.payload) {
                state.error = null;
            }
        },
        setSearchData: (state, action: PayloadAction<SearchDataResponse>) => {
            state.searchResults = action.payload.results || [];
            state.totalCount = action.payload.totalCount || 0;
            
            // Always update filter categories based on current search results
            // This ensures empty arrays properly clear the filters when no results have those categories
            state.filterCategories.contentTypes = action.payload.contentTypes || [];
            state.filterCategories.tags = action.payload.tags || [];
            
            state.isLoading = false;
            state.error = null;
        },
        setError: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        clearSearchData: (state) => {
            state.searchResults = [];
            state.totalCount = 0;
            state.error = null;
        }
    }
});

export const { setLoading,  setSearchData,  setError,  clearSearchData } = searchDataSlice.actions;

export default searchDataSlice.reducer;